import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import Customer360Panel from "../components/Customer360Panel";
import { ArrowLeft } from "lucide-react";

/**
 * Full-page Customer 360 — navigated to via /customer/:phone.
 * Uses the same panel component in `mode=page` so it stays in sync with the
 * drawer experience.
 */
const Customer360PagePage = () => {
  const { phone } = useParams();
  const nav = useNavigate();
  return (
    <div className="h-[calc(100vh-0px)] flex flex-col" data-testid="customer-360-route">
      <div className="px-4 py-2 border-b border-gray-200 bg-white">
        <button
          onClick={() => nav(-1)}
          className="text-[12px] text-gray-600 hover:text-gray-900 inline-flex items-center gap-1.5"
          data-testid="c360-page-back-btn"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Back
        </button>
      </div>
      <div className="flex-1 min-h-0">
        <Customer360Panel phone={decodeURIComponent(phone)} mode="page" />
      </div>
    </div>
  );
};

export default Customer360PagePage;
